import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OrderItem} from "../../../@services/gen/model/orderItem";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  KeyValueDto,
  Kitchen, KitchenControllerService,
  Merchant,
  PosItem,
  PosItemControllerService, PosItemVsMerchant,
  PosItemVsMerchantControllerService
} from "../../../@services/gen";
import {TdDialogService} from "@covalent/core/dialogs";

@Component({
  selector: 'app-pos-open-item-dialog',
  templateUrl: './pos-open-item-dialog.component.html',
  styleUrls: ['./pos-open-item-dialog.component.scss'],
})
export class PosOpenItemDialogComponent implements OnInit{
  openItemForm: FormGroup;
  merchant: Merchant;
  openItems: PosItemVsMerchant[];
  selectedOpenItem: PosItemVsMerchant;
  kitchen: KeyValueDto[];
  isUpdate: boolean = false;
  title = 'Create New Open Item';
  submitButton = 'Add Open Item To Cart';
  saveButton = 'Save Open Item';

  constructor(private dialogRef: MatDialogRef<PosOpenItemDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any,
              private fb: FormBuilder,
              private posItemControllerService: PosItemControllerService,
              private posItemVsMerchantControllerService: PosItemVsMerchantControllerService,
              private kitchenControllerService: KitchenControllerService,
              private ds: TdDialogService,) {
    this.merchant = data.merchant;
    this.loadOpenItemHistory();
  }

  ngOnInit(): void {
    this.loadKitchen();
    this.openItemForm = this.fb.group({
      itemName: [null, [Validators.required, Validators.minLength(1)]],
      itemPrice: [null, [Validators.required, Validators.pattern('^[0-9]+(\.[0-9]{1,2})?$')]],
      itemKitchen: [null, [Validators.required]],
    });
  }

  prepare(){
    const posItem: PosItem = {} as PosItem;
    if(this.selectedOpenItem?.posItem?.id > 0){
      posItem.id = this.selectedOpenItem.posItem?.id
    }
    posItem.name = this.openItemForm.controls['itemName'].value;
    posItem.skuNo = "OI" + this.generateRandomNumber();
    posItem.copyPriceFromHq = true;
    posItem.itemType = "POS";
    posItem.minStockTrigger = 0;
    posItem.prepareDuration = 0;
    posItem.merchant = {
      id: this.merchant.id
    };
    posItem.posItemVsMerchant = {
      price: this.openItemForm.controls['itemPrice'].value,
      averageCost: 0,
      cost: 0,
      isShow: false,
      kitchen: {
        id: this.openItemForm.controls['itemKitchen'].value
      },
      merchant: {
        id: this.merchant.id
      },
      soIsDisplay: false,
      stock: 0,
    }

    if(this.selectedOpenItem?.id > 0){
      posItem.posItemVsMerchant.id = this.selectedOpenItem.id
    }

    return posItem;
  }

  generateRandomNumber() {
    const min = 1000000000; // Minimum 10-digit number
    const max = 9999999999; // Maximum 10-digit number
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber.toString();
  }

  onSubmit(): void {
    if (this.openItemForm.valid) {

      // Handle form submission
      const _data: PosItem = this.prepare();

      this.posItemControllerService.upsertOpenItemPost({posItem: _data}).subscribe(res => {
        this.getPosItem(res)
      })
    }
  }

  saveOpenItem(){
    if (this.openItemForm.valid) {

      // Handle form submission
      const _data: PosItem = this.prepare();

      this.posItemControllerService.upsertOpenItemPost({posItem: _data}).subscribe(res => {
        this.loadOpenItemHistory();
        const posItem: PosItem = res;
        posItem.posItemVsMerchant = res.posItemVsMerchant;
        posItem.posItemVsMerchant.posItem = res;
        this.editItem(posItem.posItemVsMerchant, null);
      })
    }
  }

  cancelOpenItem(event){
    event.stopPropagation();
    this.dialogRef.close({
    });
  }

  loadOpenItemHistory(){
    this.posItemVsMerchantControllerService.getPagedOpenItemPost({
      merchantId: this.merchant.id,
      itemType: 'POS',
      pageRequest: {},
    }).subscribe(res => {
      this.openItems = res.content;
    })
  }

  loadKitchen(){
    this.kitchenControllerService.getListKitchenKeyValuePost({merchantId: this.merchant.id}).subscribe(res => {
      this.kitchen = res;
    })
  }

  private getPosItem(res: PosItem) {
    this.posItemControllerService.getPosItemPost({id: res.id, merchantId: this.merchant.id}).subscribe(data => {
      data.posItemVsMerchant.posItem = data;
      data.posItemVsMerchant.id = data.posItemVsMerchantId;
      this.dialogRef.close({
        data: data.posItemVsMerchant
      });
    })
  }

  selectOpenItem(item: PosItemVsMerchant){
    this.getPosItem(item.posItem);
  }

  newOpenItem(){
    this.isUpdate = false;
    this.selectedOpenItem = null;

    this.title = 'Create New Open Item';
    this.submitButton = 'Add Open Item To Cart';
    this.saveButton = 'Save Open Item';

    this.openItemForm.controls['itemPrice'].setValue(null);
    this.openItemForm.controls['itemName'].setValue(null);
    this.openItemForm.controls['itemKitchen'].setValue(null)
  }

  addCart(item, event){
    event.stopPropagation();
    this.selectOpenItem(item);
  }

  editItem(item, event){
    if(event){
      event.stopPropagation();
    }

    this.title = 'Update Open Item';
    this.submitButton = 'Add Open Item To Cart';
    this.saveButton = 'Update Open Item';

    this.isUpdate = true;
    this.selectedOpenItem = item;
    console.log(item);
    this.openItemForm.controls['itemPrice'].setValue(this.selectedOpenItem?.price);
    this.openItemForm.controls['itemName'].setValue(this.selectedOpenItem?.posItem?.name);
    this.openItemForm.controls['itemKitchen'].setValue(this.selectedOpenItem?.kitchen?.id)
  }

  deleteItem(item, event){
    event.stopPropagation();
    this.ds
      .openConfirm({
        title: 'Remove Open Item',
        message: 'Remove Open Item?',
      })
      .afterClosed()
      .subscribe((confirmed) => {
        if (confirmed) {
          this.posItemControllerService.deletePosItemDelete(item.posItem.id).subscribe(res => {
            this.loadOpenItemHistory();
          })
        }
      });
  }
}
